<!--
 * @FileDescription: 弹框模板（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-14（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-14（最后更新时间）
 -->
<template>
  <div class="model-lay" v-show="isShow">
    <div class="model-content" :style="{width:width+'px',height:height+'px'}">
        <img src="@/assets/image/close-model@2x.png" class="model-close"  @click.stop="onCancel"/>
        <div class="model-title">{{title}}</div>
        <div class="model-main">
            <slot></slot>
        </div>
        <div class="model-footer">
            <a-button @click.stop="onCancel" style="margin-right: 24px">{{cancelText}}</a-button>
            <a-button type="primary" @click.stop="onCofrim">{{confirmText}}</a-button>

        </div>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        width:{
            type:Number
        },
        height:{
            type:Number
        },
        title:{
            type:String
        },
        cancelText:{
            type:String,
            default:'取消'
        },
        confirmText:{
            type:String,
            default:'保存'
        },
        isShow:{
            type:Boolean
        }
    },
    data() {
        return {

        }
    },
    methods: {
        /**
        * @description: 取消按钮（方法描述）
        * @param {参数类型} 参数名称
        * @return void
        */
        onCancel(){

            this.$emit('onCancel')
        },
        /**
         * @description: 保存按钮（方法描述）
         * @param {参数类型} 参数名称
         * @return void
         */
        onCofrim(){
            this.$emit('onCofrim')
        }

    },
    components:{


    },
    watch:{

    },
    mounted(){

    },
    created(){

    }
}
</script>
<style lang="scss">
    .model-lay{
        .ant-form-item-control{
            width: 100%;
            .ant-form-item-children{
                width: 100%;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .model-lay{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100vw;
        height: 100vh;
        animation: model 0.2s ease  1 forwards;
        background: rgba(0,0,0,0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        .model-content{
            transform: scale(0);
            min-width: 680px;
            min-height: 370px;
            background: #fff;
            padding: 20px;
            box-sizing: border-box;
            position: relative;
            display: flex;
            flex-direction: column;
            animation: tran 0.3s ease  1 forwards;
            .model-close{
                position: absolute;
                top: 19px;
                right: 19px;
                width: 16px;
            }
            .model-title{
                text-align: center;
                padding-top: 10px;
                padding-bottom: 30px;
            }
            .model-main{
                flex: 1;
            }
            .model-footer{
                margin-bottom: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    @keyframes model {
        0%{
            opacity: 0;
        }
        50%{
            opacity: 0.5;
        }
        100%{
            opacity: 1;
        }
    }
      @keyframes tran {
          0%{
              transform: scale(0);
          }
          100%{
              transform: scale(1);
          }
      }
</style>
